import Glide from '@glidejs/glide';
import $ from 'jquery';

export default class HeroSlider {
  static mount() {
    $(".cm-heroslider").each(function () {
      new HeroSlider($(this));
    });
  }

  constructor($element) {
    this.$element = $element;
    this.$element.data('heroslider', this);
    this.$glide_container = $element.find(".cm-heroslider__glide");
    this.$glide = new Glide(this.$glide_container[0], {
      type: 'carousel',
      autoplay: 8000,
      animationDuration: 20,
      startAt: 0,
      perView: 1,
      gap: 100,
      hoverpause: true,
      keyboard: true,
      bound: true,

    }).mount();

  }

}